<template>
    <kiosk-layout>
        <div>
            <page-header>10DLC</page-header>

            <vx-tabs v-model="tab" size="lg" class="mb-6">
                <vx-tab value="brands" data-test="brands-tab">Brands</vx-tab>
                <vx-tab value="campaigns" data-test="campaigns-tab">Campaigns</vx-tab>
                <vx-tab value="numbers" data-test="numbers-tab">Phone Numbers</vx-tab>
            </vx-tabs>

            <div v-if="visited.brands" v-show="tab === 'brands'" data-test="brands-panel">
                <kiosk-tcr-brands></kiosk-tcr-brands>
            </div>

            <div v-if="visited.campaigns" v-show="tab === 'campaigns'" data-test="campaigns-panel">
                <kiosk-tcr-campaigns></kiosk-tcr-campaigns>
            </div>

            <div v-if="visited.numbers" v-show="tab === 'numbers'" data-test="numbers-panel">
                <kiosk-tcr-phone-numbers></kiosk-tcr-phone-numbers>
            </div>
        </div>
    </kiosk-layout>
</template>

<script lang="ts" setup>
import { VxTab, VxTabs } from '@voxie/frontend-components';
import { reactive, ref, watch } from 'vue';
import PageHeader from '~/components/general/PageHeader.vue';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import KioskTcrBrands from '~/components/kiosk/kiosk-ten-dlc/KioskTcrBrands.vue';
import KioskTcrCampaigns from '~/components/kiosk/kiosk-ten-dlc/KioskTcrCampaigns.vue';
import KioskTcrPhoneNumbers from '~/components/kiosk/kiosk-ten-dlc/KioskTcrPhoneNumbers.vue';

type Tab = 'brands' | 'campaigns' | 'numbers';

const tab = ref<Tab>('brands');

// Panels mount lazily the first time their tab is opened and then stay mounted
// so switching back does not refetch the list.
const visited = reactive<Record<Tab, boolean>>({
    brands: false,
    campaigns: false,
    numbers: false,
});

watch(
    tab,
    (value) => {
        visited[value] = true;
    },
    { immediate: true }
);
</script>
